import { type FC, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { type UserOrderResponseWithFlagsSubOrdersInner } from '@redteclab/api/clients/bully'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { useOpenableControls } from '../../../../generic-hooks'
import { type DirectContactFormValues } from '../DirectContactFormModel'

import { DirectContactFormOrderProductsSelectionContent } from './DirectContactFormOrderProductsSelectionContent'
import { DirectContactFormOrderSelectionField } from './DirectContactFormOrderSelectionField'
import { DirectContactFormProductSelectionField } from './DirectContactFormProductSelectionField'

export const DirectContactFormOrderProductsSelection: FC<{
  isProductType: boolean
}> = ({ isProductType }) => {
  const modalControls = useOpenableControls()
  const [selectedSubOrder, setSelectedSubOrder] =
    useState<UserOrderResponseWithFlagsSubOrdersInner | null>(null)
  const [isSelectingProducts, setIsSelectingProducts] = useState(false)
  const { clearErrors, control } = useFormContext<DirectContactFormValues>()
  const selectedOrderNumber = useWatch({ control, name: 'orderId' })
  const shouldShowProductSelectionField =
    isProductType && Boolean(selectedOrderNumber)
  const shouldShowProductSelectionTitle =
    isSelectingProducts && Boolean(selectedSubOrder)
  const handleOpenOrderSelection = (): void => {
    clearErrors('orderId')
    setIsSelectingProducts(false)
    modalControls.handleOpen()
  }
  const handleOpenProductSelection = (): void => {
    clearErrors('productCode')
    setIsSelectingProducts(true)
    modalControls.handleOpen()
  }

  return (
    <>
      <div className="grid gap-4">
        <DirectContactFormOrderSelectionField
          onClick={handleOpenOrderSelection}
        />

        {shouldShowProductSelectionField ? (
          <DirectContactFormProductSelectionField
            onClick={handleOpenProductSelection}
          />
        ) : null}
      </div>

      <Dialog
        data-qa-id="direct-contact-order-products-selection-dialog"
        onClose={modalControls.handleClose}
        open={modalControls.isOpen}
      >
        <DialogTitle onClose={modalControls.handleClose}>
          {shouldShowProductSelectionTitle ? (
            <FormattedMessage id="direct.contact.form.select.product.title" />
          ) : (
            <FormattedMessage id="direct.contact.form.select.order" />
          )}
        </DialogTitle>
        <DialogContent>
          <DirectContactFormOrderProductsSelectionContent
            modalControls={modalControls}
            onSelectSubOrder={(subOrder) => {
              if (subOrder) {
                setSelectedSubOrder(subOrder)
                setIsSelectingProducts(true)
              } else {
                setIsSelectingProducts(false)
              }
            }}
            selectedSubOrder={isSelectingProducts ? selectedSubOrder : null}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
